import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromAlmConfiguration from './alm-configuration.reducers';

export interface AlmConfigurationState {
  stateData: fromAlmConfiguration.State;
}

export interface State extends fromRoot.AppState {
  almConfiguration: AlmConfigurationState;
}

export const reducers = {
  stateData: fromAlmConfiguration.reducer
};

export const selectAlmConfigurationState = createFeatureSelector<AlmConfigurationState>('almConfiguration');

export const selectAlmConfigurationStateData = createSelector(selectAlmConfigurationState, (state: AlmConfigurationState) => state.stateData);

export const getAlmConfigurationState = createSelector(selectAlmConfigurationStateData, fromAlmConfiguration.getStateData);

export const getAlmConfigurationScreenError = createSelector(selectAlmConfigurationStateData, fromAlmConfiguration.getError);

export const getAlmConfigurationScreenPending = createSelector(selectAlmConfigurationStateData, fromAlmConfiguration.getPending);